import React from 'react';
import {Route} from 'react-router';
import LoginPage from '@components/login/LoginPage';
import TokenLoginPage from 'components/TokenLoginPage';
import PasswordPage from 'components/PasswordPage';
import PasswordForgot from '@components/password/PasswordForgot';
import {PasswordResetContainer} from '@components/password/PasswordResetContainer';
import {PasswordWelcomeContainer} from '@components/password/PasswordWelcomeContainer';

export const authRoutes = (
  <>
    {/* TODO extract sidebar structure to shared component */}

    {/* Login*/}
    <Route path="login" component={LoginPage} />
    <Route path="ia_login/:userId/:token" component={TokenLoginPage} />
    <Route path="sso_login/:userId/:token" component={TokenLoginPage} />

    {/* Passwords*/}
    <Route path="password" component={PasswordPage}>
      <Route path="forgot" component={PasswordForgot} />
      <Route path="new/:code" component={PasswordResetContainer} />
    </Route>
    {/* Would've nested this in /password, but PasswordPage sets up Coach.jpg sidebar layout & this needs full-screen */}
    <Route path="welcome/:code" component={PasswordWelcomeContainer} />
  </>
);
